export const services = [
  {
    id: 1,
    name: "Hair Removal",
    items: [
      {
        id: 1,
        name: "Eyebrows shaping",
        price: "$16 & up",
      },
      {
        id: 2,
        name: "Upper Lip",
        price: "$13 & up",
      },
      { id: 3, name: "Chin", price: "$13 & up" },
      { id: 4, name: "Forhead", price: "$15 & up" },
      { id: 5, name: "Lower lip", price: "$12 & up" },
      { id: 6, name: "Under Eye", price: "$12 & up" },
      { id: 7, name: "Side burns", price: "$16 & up" },
      { id: 8, name: "Neck", price: "$15 & up" },
      { id: 9, name: "Men's eyebrows", price: "$18 & up" },
      { id: 10, name: "Full face Thrading", price: "$55 & up" },
    ],
  },
  {
    id: 2,
    name: "Tinting and Henna",
    items: [
      { id: 1, name: "Eyebrows Tinting", price: "$25 & up" },
      { id: 2, name: "Eyebrows Henna", price: "$35 & up" },
      { id: 3, name: "Eyelashes Tinting", price: "$45 & up" },
      { id: 4, name: "Eyebrow Lamination", price: "$99 & up" },
    ],
  },
  {
    id: 3,
    name: "Lash lift and Tint",
    items: [
      { id: 1, name: "Lash Lift", price: "$90 & up" },
      { id: 2, name: "Lash Tint", price: "$45 & up" },
    ],
  },
  {
    id: 4,
    name: "Facial",
    items: [
      { id: 1, name: "D-Tan", price: "$25 & up" },
      { id: 2, name: "Face fruit bleach", price: "$35 & up" },
      { id: 3, name: "Back facial", price: "$55 & up" },
      { id: 4, name: "Express mini facial", price: "$55 & up" },
      { id: 5, name: "Gold facial", price: "$75 & up" },
      { id: 6, name: "Derma planing.", price: "$80 & up" },
      { id: 7, name: "Teen facial", price: "$95 & up" },
      { id: 8, name: "Man Rescue facial", price: "$95 & up" },
      { id: 9, name: "Dimond facial", price: "$95 & up" },
      { id: 10, name: "Anti acne facial", price: "$100 & up" },
      { id: 11, name: "O3+ facial", price: "$120 & up" },
      { id: 12, name: "Glofacial Hydro infusion", price: "$25 (addon)" },
    ],
  },
  {
    id: 5,
    name: "Waxing",
    items: [
      { id: 1, name: "Eyebrows waxing", price: "$18 & up" },
      { id: 2, name: "Under Arms", price: "$25 &up" },
      { id: 3, name: "Half Arms", price: "$40 & up" },
      { id: 4, name: "Full Arms", price: "$50 & up" },
      { id: 5, name: "Lower and Upper Legs", price: "$48 & up" },
      { id: 6, name: "Full  Legs", price: "$80 & up" },
      { id: 7, name: "Bikini Line", price: "$45 &up" },
      { id: 8, name: "Brazilian", price: "$60 & up" },
      { id: 9, name: "Full Back", price: "$60 & up" },
      { id: 10, name: "Stomach", price: "$40 & up" },
      { id: 11, name: "Full face waxing", price: "$65 & up" },     
      { id: 12, name: "Men's eyebrows", price: "$20 & up" },
      { id: 13, name: "Upper lip", price: "$15 & up" },
      { id: 14, name: "Chin", price: "$15 & up" },
      { id: 15, name: "Side burns", price: "$18 & up" },
      { id: 16, name: "Neck", price: "$18 & up" },
    ],
  },
  {
    id: 6,
    name: "Eyelashes Extensions",
    items: [
      { id: 1, name: "Classic full set", price: "$125 & up" },
      { id: 2, name: "Fill in (2 weeks)", price: "$70 & up" },
      { id: 3, name: "Individual", price: "$85 & up" },
      { id: 4, name: "Extension remove", price: "$20 & up" },
      { id: 5, name: "Hybrid", price: "$150 & up" },
      { id: 6, name: "Volume", price: "$170 & up" },
    ],
  },
  {
    id: 7,
    name: "Henna Temporary Tattoo",
    price: "$20 & up",
  },
  {
    id: 8,
    name: "Hair Services",
    items: [
      { id: 1, name: "Hot oil treatment", price: "$40 & up" },
      { id: 2, name: "Deep conditioning", price: "$40 & up" },
      { id: 3, name: "Henna Treatment", price: "$65 & up" },
      { id: 4, name: "Color Hair starting At", price: "$90 & up" },
      { id: 5, name: "Half Foil", price: "$115 & up" },
      { id: 6, name: "Full foil", price: "$135 & up" },
      { id: 7, name: "Balayage", price: "$160 & up" },
      { id: 8, name: "Blowout", price: "$35 & up" },
      { id: 9, name: "Man's Haircut", price: "$25 & up" },
      { id: 10, name: "Women Haircut", price: "$38 & up" },
      { id: 11, name: "Kids Haircut (below 12 age)", price: "$20 & up" },
      { id: 12, name: "Bang trim", price: "$15 & up" },
      { id: 13, name: "Updo hairstyle", price: "$55 & up" },
    ],
  },
  {
    id: 9,
    name: "Party makeup and Hairstyle",
    items: [
      { id: 1, name: "Makeup applications", price: "$65 & up" },
      { id: 2, name: "Hairstyle", price: "$45 & up" },
    ],
  },
];
